import TransferList from './TransferList';

const ActivityPanel = ({
  isMobileLayout = false,
  mobilePanelTab = 'activity',
  activityHeight = 240,
  setActivityHeight,
  transferTab = 'actions',
  setTransferTab,
  transfers,
  onCancelTransfer,
  onCancelAllTransfers,
  logs
}) => (
  <section
    className="glass-panel rounded-2xl flex flex-col overflow-hidden"
    style={isMobileLayout && mobilePanelTab === 'activity' ? { flex: 1, minHeight: 0 } : { height: `${activityHeight}px`, flexShrink: 0 }}>
    <div
      className="h-2 cursor-row-resize flex items-center justify-center hover:bg-white/5 transition shrink-0"
      onMouseDown={(e) => {
        e.preventDefault();
        const startY = e.clientY;
        const startH = activityHeight;
        const onMove = (ev) => {
          const delta = startY - ev.clientY;
          setActivityHeight(Math.max(120, Math.min(window.innerHeight * 0.7, startH + delta)));
        };
        const onUp = () => {
          window.removeEventListener('mousemove', onMove);
          window.removeEventListener('mouseup', onUp);
        };
        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onUp);
      }}>
      <div className="w-10 h-1 rounded-full bg-border/60" />
    </div>
    <div className="flex-1 flex flex-col min-h-0 px-4 pb-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <p className="text-sm font-semibold text-textMuted">Activity</p>
          <div className="flex items-center gap-2">
            <button
              type="button"
              className={`ghost-button px-3 py-1 ${transferTab === 'actions' ? 'border-accent text-accent' : ''}`}
              onClick={() => setTransferTab('actions')}>
              Actions
            </button>
            <button
              type="button"
              className={`ghost-button px-3 py-1 ${transferTab === 'log' ? 'border-accent text-accent' : ''}`}
              onClick={() => setTransferTab('log')}>
              Console
            </button>
          </div>
        </div>
        <div className="text-sm text-textMuted">Uploads, downloads, edits</div>
      </div>
      {transferTab === 'actions' ?
        <div className="mt-4 flex-1 min-h-0 overflow-y-auto">
          <TransferList transfers={transfers} onCancel={onCancelTransfer} onCancelAll={onCancelAllTransfers} />
        </div> :
        <div className="mt-4 flex-1 min-h-0 overflow-y-auto rounded-lg border border-border bg-inset/60 p-3 text-sm text-textMuted font-mono space-y-1">
          {logs.length === 0 ? <div>No log entries.</div> : logs.map((line, idx) => <div key={idx}>{line}</div>)}
        </div>}
    </div>
  </section>
);

export default ActivityPanel;
